import { Injectable } from '@angular/core';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class AlertServiceService {

  constructor() { }
  successPop(message: any) {
    Swal.fire({
      title: 'Success',
      text: message,
      icon: 'success',
    }).then(() =>
    // {}
     window.location.reload()
    // console.log('windows history')
    
     );
  }

  successPop2(message: any) {
    Swal.fire({
      title: 'Successful!',
      text: message,
      icon: 'success',
    }).then(() =>{}
    //  window.history.back()
    // console.log('windows history')
    
     );
  }

  errorPop(message: any) {
    Swal.fire({
      title: 'Oops!',
      text: message,
      icon: 'error',
    });
  }

  timerMessage(message: any) {
    Swal.fire({
      position: 'top-end',
      icon: 'success',
      title: message,
      showConfirmButton: false,
      timer: 1500,
    });
  }

  successToast(message: any) {
    const Toast = Swal.mixin({
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer);
        toast.addEventListener('mouseleave', Swal.resumeTimer);
      },
    });

    Toast.fire({
      icon: 'success',
      title: message,
    }).then(() => location.reload());
  }

  successToastFound(message: any) {
    const Toast = Swal.mixin({
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer);
        toast.addEventListener('mouseleave', Swal.resumeTimer);
      },
    });

    Toast.fire({
      icon: 'success',
      title: message,
    });
  }

  errorToast(message: any) {
    const Toast = Swal.mixin({
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer);
        toast.addEventListener('mouseleave', Swal.resumeTimer);
      },
    });

    Toast.fire({
      icon: 'error',
      title: message,
    });
  }

  updateAdmin(message: any) {
    Swal.fire({
      title: 'Update!',
      text: message,
      icon: 'info',
    });
  }

  showLoading() {
    Swal.fire({
      allowEscapeKey: false,
      allowOutsideClick: false,
      text: 'Please wait',
    }).then;
    Swal.showLoading();
  }

  showInfo(message: any) {
    Swal.fire({
      title: 'Alert',
      text: message,
      icon: 'info',
    });
  }

  hideLoading(event: any = '') {
    Swal.fire({
      allowEscapeKey: false,
      allowOutsideClick: true,
      text: event,
    }).then;
    Swal.hideLoading();
  }
}
